import fbIcon from "../../assets/icons/facebook.png";
import youTubeIcon from "../../assets/icons/youtube.png";
import linkedInIcon from "../../assets/icons/linkedin.png";
import xIcon from "../../assets/icons/x.png";
import instaIcon from "../../assets/icons/instaIcon.png";
import { toast } from "..";
import { OpenPopUp } from "../../utils";
import { RootState } from "../../store";
import { ConnectedProps, connect } from "react-redux";
import { SocialChannel } from "@/store/app/app.models";
import { updatePlaylist, updateSocialChannel } from "@/store/app/app.actions";
import dailyMotionIcon from "../../assets/icons/dailymotion.png";
import {
  Linkedin,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Waypoints,
} from "lucide-react";

const dummySocialOptions: { id: number; img: string; type: string; title: string; Icon: React.ElementType; disabled?: boolean }[] = [
  {
    id: 1,
    img: fbIcon,
    type: "facebook",
    title: "Facebook",
    Icon: Facebook,
  },
  {
    id: 2,
    img: youTubeIcon,
    type: "youtube",
    title: "Youtube",
    Icon: Youtube,
  },
  {
    id: 3,
    img: xIcon,
    type: "twitter",
    title: "X",
    Icon: Twitter,
    disabled: true,
  },
  {
    id: 4,
    img: instaIcon,
    type: "instagram",
    title: "Instagram",
    Icon: Instagram,
  },
  {
    id: 5,
    img: linkedInIcon,
    type: "linkedin",
    title: "LinkedIn",
    Icon: Linkedin,
  },
  {
    id: 6,
    img: dailyMotionIcon,
    type: "dailymotion",
    title: "DailyMotion",
    Icon: Waypoints,
  },
];

type Props = {
  handleAddChannel: (channels: SocialChannel[]) => void;
  handleModalClose: () => void;
};

const SocialCreate = ({
  handleAddChannel,
  handleModalClose,
  updatePlaylist,
}: CombinedProps) => {
  const handleClick = async (type: string) => {
    handlePopup(type);
    handleModalClose();
  };
  const socialBackend = process.env.NX_APP_SOCIAL_BACKEND ?? "";

  const handlePopup = async (platform: string) => {
    try {
      const { data, popup } = await OpenPopUp(socialBackend, {
        platform,
      });

      if (data.Error && data.Error.length > 0) {
        toast.fail(data.Error || "");
      } else if (data.Payload && data.Payload.length > 0) {
        const channels = data.Payload.map((channel: any) => {
          return {
            name: channel.name,
            // videosCount: 0,
            mt: channel.mt || Date.now(),
            active: true,
            platform: platform,
            image: channel.image,
            id: channel?.id || channel?.channel,
            user: channel.user,
          };
        });

        handleAddChannel(channels);
        if (platform === "youtube") {
          channels.forEach((channel: any) => {
            updatePlaylist(channel.id);
          });
        }
      }
    } catch (error) {
      toast.fail("");
    }
  };

  return (
    <div className="settings-grid p-2 pt-3 border-top gap-3">
      {dummySocialOptions.map(({ id, img, title, type, Icon, disabled }, index) => (
        <div key={id} className={`create-btn bg-white${disabled ? " opacity-50" : ""}`}>
          <button
            onClick={(e) => !disabled && handleClick(type)}
            disabled={disabled}
            className="card-link setting-item"
            style={disabled ? { cursor: "not-allowed", pointerEvents: "none" } : {}}
          >
            <Icon size={24} strokeWidth={1.5} />
            <span className="pt-2">{title}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

const mapState = (state: RootState) => ({});

const mapDispatch = {
  updatePlaylist,
  updateSocialChannel,
};

const connector = connect(mapState, mapDispatch);
type CombinedProps = ConnectedProps<typeof connector> & Props;
export default connector(SocialCreate);
